export default "__VITE_ASSET__C6HL2zlq__"